import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
import {CustomEase} from 'gsap/CustomEase';
gsap.registerPlugin( ScrollTrigger, CustomEase );
( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;
    },
    finalize: function() {
    },
    animate: function() {
      if ( !window.matchMedia( '(prefers-reduced-motion)' ).matches ) {
        $( `
        .js-fade:not(.js-ignore),
        .js-reveal:not(.js-ignore),
        .js-fade-group
        ` ).each( function() {
          gsap.registerPlugin( ScrollTrigger );
          const tl = gsap.timeline( {
            scrollTrigger: {
              trigger: this,
              start: 'top 80%',
              scrub: 0.15,
              onRefresh: ( self ) => {
                if ( self.progress > 0 ) {
                  $( this ).addClass( 'js-animated' );
                }
              },
              onEnter: ( {progress, direction, isActive} ) => {
                if ( $( this ).hasClass( 'js-fade-group' ) ) {
                  $( this ).find( '> *' ).each( function( childKey, child ) {
                    const delay = ( childKey + 1 ) / 10;
                    child.style.setProperty( '--fade-group-delay', delay + 's' );
                  } );
                }
                $( this ).addClass( 'js-animated' );
              },
            },
          } );
        } );
        $( `
          .js-fade.fade-on-load:not(.js-ignore),
          .js-reveal.fade-on-load:not(.js-ignore),
          .js-fade-group.fade-on-load
          ` ).each( function() {
          gsap.registerPlugin( ScrollTrigger );
          const tl = gsap.timeline( {
            scrollTrigger: {
              trigger: this,
              start: 'top 100%',
              scrub: 0.15,
              onRefresh: ( self ) => {
                if ( self.progress > 0 ) {
                  $( this ).addClass( 'js-animated' );
                }
              },
              onEnter: ( {progress, direction, isActive} ) => {
                if ( $( this ).hasClass( 'js-fade-group' ) ) {
                  $( this ).find( '> *' ).each( function( childKey, child ) {
                    const delay = ( childKey + 1 ) / 10;
                    child.style.setProperty( '--fade-group-delay', delay + 's' );
                  } );
                }
                $( this ).addClass( 'js-animated' );
              },
            },
          } );
        } );

        $( '.js-draw-line-down-on-scroll' ).each( function() {
          gsap.set( this, {clipPath: 'inset(0 0 100% 0)'} );
          const tl = gsap.timeline( {
            scrollTrigger: {
              trigger: this,
              start: 'top 80%',
              scrub: 0.15,
              onRefresh: ( self ) => {
                if ( self.progress > 0 ) {
                  $( this ).addClass( 'js-animated' );
                }
              },
              onEnter: () => {
                $( this ).addClass( 'js-animated' );
              },
            },
          } );
          tl.to( this, {
            clipPath: 'inset(0 0 0% 0)',
            ease: 'power2.out',
          } );
        } );

        $( '.js-draw-line-down' ).each( function() {
          gsap.set( this, {clipPath: 'inset(0 0 100% 0)'} );
          ScrollTrigger.create( {
            trigger: this,
            start: 'top 80%',
            once: true,
            onEnter: () => {
              $( this ).addClass( 'js-animated' );
              gsap.to( this, {
                clipPath: 'inset(0 0 0% 0)',
                duration: 1,
                ease: 'power2.out',
              } );
            },
            onRefresh: ( self ) => {
              if ( self.progress > 0 ) {
                $( this ).addClass( 'js-animated' );
                gsap.set( this, {clipPath: 'inset(0 0 0% 0)'} );
              }
            },
          } );
        } );

        $( '.js-draw-line-right' ).each( function() {
          gsap.set( this, {clipPath: 'inset(0 100% 0 0)'} );
          ScrollTrigger.create( {
            trigger: this,
            start: 'top 80%',
            once: true,
            onEnter: () => {
              $( this ).addClass( 'js-animated' );
              gsap.to( this, {
                clipPath: 'inset(0 0% 0 0)',
                duration: 1,
                ease: 'power2.out',
              } );
            },
            onRefresh: ( self ) => {
              if ( self.progress > 0 ) {
                $( this ).addClass( 'js-animated' );
                gsap.set( this, {clipPath: 'inset(0 0% 0 0)'} );
              }
            },
          } );
        } );
      }
    },
    onError: function() {
      document.querySelectorAll( '.js-fade' )?.forEach( ( el ) => {
        el.classList.remove( 'js-fade' );
      } );
    },
  };
  app.registerComponent( 'animations', COMPONENT );
} )( app );
